import { render, staticRenderFns } from "./OfficeAuthenticationFailed.vue?vue&type=template&id=4e368618"
import script from "./OfficeAuthenticationFailed.vue?vue&type=script&lang=ts"
export * from "./OfficeAuthenticationFailed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports